import { Route } from '@angular/router';
import { PermissionFeature } from '@price-management-console/permissions';
import { Home } from '../app/home/home';
import { authGuard } from './core/guards/auth.guard';
import { hasAnyPermissionGuard } from './core/guards/has-any-permission.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { AuthenticatedLayout } from './core/shell/authenticated-layout/authenticated-layout/authenticated-layout';
import { PublicLayout } from './core/shell/public-layout/public-layout/public-layout';
import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AuthenticatedLayout,
    canActivate: [authGuard, hasAnyPermissionGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        component: Home,
      },
      {
        path: 'routing-protocol',
        canActivate: [permissionGuard],
        data: {
          feature: PermissionFeature.RoutingProtocol,
        },
        loadChildren: () =>
          import('@price-management-console/routing-protocol').then(
            (m) => m.routingProtocolRoutes
          ),
      },
    ],
  },
  {
    path: '',
    component: PublicLayout,
    children: [
      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
      },
    ],
  },
];
